"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadPopulationFile = void 0;
var BaseFile_1 = require("@cck/common/dist/data/BaseFile");
var Evaluation = __importStar(require("@cck/common/dist/data/Evaluation"));
var lodash_1 = __importDefault(require("lodash"));
var moment_1 = __importDefault(require("moment"));
var firebase = __importStar(require("../firebase/fbase"));
var StorageManager_1 = require("../storage/StorageManager");
var EvaluationLoader = __importStar(require("./EvaluationLoader"));
var EvaluationUtils_1 = require("./EvaluationUtils");
/**
 *  3MB 크기 이상의 모집단 파일을 바로 업로드한다.
 * @param population
 * @returns
 */
function uploadPopulationFile(population) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var userId, contentData, collectionName, basePath, originalName, originalPath, newPopulationFilePath, newFile, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    userId = (_a = firebase.authService.currentUser) === null || _a === void 0 ? void 0 : _a.email;
                    if (!userId) {
                        return [2 /*return*/, Promise.reject(new Error('모집단 파일 업데이트 - 로그인한 유저를 찾을 수 없습니다.'))];
                    }
                    if (!population || population.state !== BaseFile_1.FileState.OK || !population.file) {
                        return [2 /*return*/, Promise.reject(new Error('undefined file'))];
                    }
                    return [4 /*yield*/, EvaluationLoader.getContent(population.evaluationType, population.evaluationName, population.controlId)];
                case 1:
                    contentData = _d.sent();
                    collectionName = Evaluation.getKoEvaluation(Evaluation.Type.Operation);
                    basePath = "/".concat(collectionName, "/").concat(population.evaluationName, "/").concat(population.controlId);
                    originalName = ((_b = contentData.files.population) === null || _b === void 0 ? void 0 : _b.name) || '';
                    originalPath = !lodash_1.default.isEmpty(originalName) ? "".concat(basePath, "/").concat(originalName) : '';
                    if (!(originalName !== '' && originalName !== population.name)) return [3 /*break*/, 3];
                    return [4 /*yield*/, (0, StorageManager_1.deleteFile)(originalPath)];
                case 2:
                    _d.sent();
                    _d.label = 3;
                case 3:
                    newPopulationFilePath = "".concat(basePath, "/").concat(population.name);
                    return [4 /*yield*/, (0, StorageManager_1.uploadFile)(newPopulationFilePath, population.file)
                        // DB Update
                    ];
                case 4:
                    _d.sent();
                    newFile = lodash_1.default.cloneDeep(population);
                    newFile.updateTime = (0, moment_1.default)().format('YYYY-MM-DD HH:mm:ss');
                    newFile.updater = userId;
                    _c = newFile;
                    return [4 /*yield*/, (0, StorageManager_1.hasFile)(Evaluation.Type.Operation, population.evaluationName, population.controlId, newFile.name)];
                case 5:
                    _c.checked = _d.sent();
                    lodash_1.default.unset(newFile, 'file');
                    return [4 /*yield*/, firebase.dbService
                            .collection(collectionName)
                            .doc(population.evaluationName)
                            .collection(EvaluationUtils_1.CONTENT_DOC_NAME)
                            .doc(population.controlId)
                            .update({ 'files.population': newFile })];
                case 6:
                    _d.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.uploadPopulationFile = uploadPopulationFile;
//# sourceMappingURL=EvaluationFileUploader.js.map